import { z } from 'zod'

export const portfolioSnapshotResponseSchema = z.object({
  displayCurrency: z.string(),
  cashValue: z.number(),
  positionsValue: z.number(),
  totalValue: z.number(),
  syncedAt: z.coerce.date(),
})

export type PortfolioSnapshotResponseDto = z.infer<typeof portfolioSnapshotResponseSchema>
